import { Machine } from "xstate";

const projectFilesMachine = Machine({
  id: "projectFilesMachine",
  initial: "idle",
  states: {
    idle: {
      on: {
        RELOAD: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "idle",
        REJECT: "error",
      },
    },
    error: {
      type: "final",
    },
  },
});

export default projectFilesMachine;
